// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"542":"bbc8b53a","550":"afa82b23","695":"73453a6e","779":"afa82b23","844":"7893e186","879":"7893e186"}[chunkId] + ".css";
};